module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Снять выбор":"Clear selection","Выберите":"Please select","Выберите счет":"Please select account"}}')
  delete Component.options._Ctor
}
